  import { Flex, Image, useBreakpointValue } from "@chakra-ui/react"
  import { Link } from "@tanstack/react-router"

  import Logo from "/assets/images/atech-logo.svg"
  import UserMenu from "./UserMenu"

  function Navbar() {
    const display = useBreakpointValue({ base: "none", md: "flex" })

    return (
      <Flex
        display={display}
        justify="space-between"
        position="sticky"
        color="white"
        align="center"
        bg="bg.secondary"
        w="100%"
        h="64px"
        top={0}
        p={4}
      >
        <Link to="/">
          <Image src={Logo} alt="Logo" w="74px" h="40px" maxW="2xs"/>
        </Link>
        <Flex gap={2} alignItems="center">
          <UserMenu />
        </Flex>
      </Flex>
    )
  }

  export default Navbar
